import { useTranslation } from "react-i18next";
import { FormikVehicle, YesNoAnswer } from "src/types";
import { useVehicleOwnerTypeOptions, useYesNoAnswer } from "src/utils";

export const useDataEntryVehicleStepOwner = (
  formikVehicleValues: FormikVehicle
) => {
  const { t } = useTranslation();
  const { vehicleOwnerTypeOptions } = useVehicleOwnerTypeOptions();
  const { yesNoOptions } = useYesNoAnswer();

  const ownerFormVisibile =
    formikVehicleValues.owner.ownerCoincidesWithContractor === YesNoAnswer.NO;

  return { vehicleOwnerTypeOptions, yesNoOptions, ownerFormVisibile, t };
};
